import { render, staticRenderFns } from "./RoleManagementEdit.vue?vue&type=template&id=1bf3119b&"
import script from "./RoleManagementEdit.vue?vue&type=script&lang=js&"
export * from "./RoleManagementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports